<mat-form-field class="range-field">
  <mat-label>{{ startLabel | translate }}</mat-label>
  <input readonly matInput [matDatepicker]="startPicker" [matDatepickerFilter]="startFilter"
    [value]="start" (dateChange)="onStart($event.value)">
  <button type="button" mat-icon-button matSuffix *ngIf="clearable && start" (click)="clear($event, 'start')"
    [matTooltip]="'common.actions.clearNamed' | translate: { name: (startLabel | translate) }"
    [attr.aria-label]="'common.actions.clearNamed' | translate: { name: (startLabel | translate) }">
    <mat-icon>clear</mat-icon>
  </button>
  <mat-datepicker-toggle #startToggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
  <mat-datepicker #startPicker [startAt]="start ?? end" [dateClass]="startDateClass"></mat-datepicker>
</mat-form-field>

<mat-form-field class="range-field">
  <mat-label>{{ endLabel | translate }}</mat-label>
  <input readonly matInput [matDatepicker]="endPicker" [matDatepickerFilter]="endFilter"
    [value]="end" (dateChange)="onEnd($event.value)">
  <button type="button" mat-icon-button matSuffix *ngIf="clearable && end" (click)="clear($event, 'end')"
    [matTooltip]="'common.actions.clearNamed' | translate: { name: (endLabel | translate) }"
    [attr.aria-label]="'common.actions.clearNamed' | translate: { name: (endLabel | translate) }">
    <mat-icon>clear</mat-icon>
  </button>
  <mat-datepicker-toggle #endToggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
  <mat-datepicker #endPicker [startAt]="end ?? start" [dateClass]="endDateClass"></mat-datepicker>
</mat-form-field>
